import axios from 'axios';
import { useEffect, useRef } from 'react';

export default (campSiteId: string) => {
  const refFirstRef = useRef(true);
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      if (refFirstRef.current) {
        refFirstRef.current = false;
        return;
      }
    }
    const key = `accessCountCampIds`;
    const item: string[] = JSON.parse(
      localStorage.getItem(key) ?? JSON.stringify([])
    );
    if (item.includes(campSiteId)) {
      return;
    }
    axios.post('/api/incrCount', { campSiteId }).then(() => {
      item.push(campSiteId);
      localStorage.setItem(key, JSON.stringify(item));
    });
  }, []);
};
